<template>
  <b-modal
    :id="id"
    :title="trans('credit_card_stripe')"
    :ok-title="trans('apply')"
    :ok-disabled="busy"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @hidden="onHidden"
    @ok="onApply"
  >
    <b-form-group v-if="!!intent_id && !!client_cc" :label="trans('cc_on_file')">
      <p>
        <span v-if="client_cc.brand">
          {{ client_cc.brand.toUpperCase() }}
        </span>
        XXXX XXXX XXXX {{ client_cc.last4 }}
        <span class="text-muted ml-2">exp.</span>
        <strong>{{ client_cc.exp_month}}/{{ client_cc.exp_year }}</strong>
      </p>
    </b-form-group>

    <p v-if="!!intent_id && !client_cc">{{ trans('no_cc') }}</p>

    <b-form-group v-if="!!intent_id">
      <label>{{ trans(!client_cc ? 'add_credit_card' : 'update_credit_card') }}</label>
      <div ref="card"></div>
    </b-form-group>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  let stripe = undefined
  let elements = undefined
  let card = undefined
  let style = {
    base: {
      fontSize: '16px',
      lineHeight: '24px',
      color: "#000",
    },

    invalid: {
      // All of the error styles go inside of here.
    }
  }

  export default {
    props: {
      id: {
        type: String,
        default: 'stripe-credit-card-modal',
      },
      organization: Object,
      client: Object, // null on admin side
      recipientId: Number,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        numeral: numeral,
        currency: _.currency,
        // Stripe payment
        intent_id: null,
        customer_id: null,
        stripe_account_id: null,
        stripe_public_key: null,
        client_secret: null,
        name_on_card: null,
        // Existing card?
        client_cc: null,
        // Stripe result
        stripe_payment_method_id: null,
      }
    },
    computed: {
      url() {
        return !!this.client ?
          `/org/${this.organization.id}/client/credit_card_on_file/${this.recipientId}` :
          `/organization/${this.organization.id}/recipient/${this.recipientId}/credit_card_on_file`
      },
      serialized() {
        return {
          stripe_payment_method_id: this.stripe_payment_method_id,
        }
      },
    },
    methods: {
      onShown() {
        this.$nextTick(() => {
          this.loadCreditCardOnFile()
        })
      },
      loadCreditCardOnFile() {
        this.busy = true
        this.error = false
        return axios.post(this.url+'/prepare')
        .then(response => {
          this.busy = false

          this.intent_id = response.data.intent_id
          this.customer_id = response.data.customer
          this.stripe_account_id = response.data.account_id
          this.stripe_public_key = response.data.public_key
          this.client_secret = response.data.client_secret

          this.client_cc = response.data.card // can be null if there is no credit card on file

          setTimeout(this.onReady.bind(this), 100) // could be better
        })
        .catch(error => {
          this.busy = false
          this.items = []
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
      onHidden() {
        this.busy = false
        this.error = null
        this.intent_id = null
        this.customer_id = null
        this.stripe_public_key = null
        this.client_secret = null
        this.stripe_account_id = null
        this.name_on_card = null
        this.stripe_payment_method_id = null
        this.client_cc = null
      },
      onApply(e) {
        e.preventDefault()
        return this.onStripeSave()
      },
      onReady() {
        stripe = Stripe(this.stripe_public_key, {
          stripeAccount: this.stripe_account_id
        })
        elements = stripe.elements()
        card = elements.create('card', {
          style: style,
          hidePostalCode: true,
        })
        card.mount(this.$refs.card);
      },
      onStripeSave() {
        this.busy = true
        this.error = null

        stripe.confirmCardSetup(this.client_secret, {
          payment_method: {
            card: card,
            billing_details: {name: this.name_on_card},
          },
        })
        .then(result => {
          if (result.error) {
            this.busy = false
            this.error = result.error.message
            return
          }
          this.stripe_payment_method_id = result.setupIntent.payment_method
          this.$nextTick(this.onSave)
        })
      },
      onSave() {
        this.busy = true
        this.error = null
        axios.post(this.url, this.serialized)
        .then(response => {
          this.busy = false
          this.$emit('saved', response.data)
          this.$bvModal.hide(this.id)
          this.$bvToast.toast(trans('success'), {
            title: trans('success'),
            variant: 'success',
            solid: true,
          })
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.stripeCCModal = this
    },
  }
</script>
